export const colors = {
  primary: {
    lightest: "magenta",
    lighter: "pink",
    light: "var(--t-fill-color-product-registrations-light)",
    base: "var(--t-fill-color-product-registrations-base)",
    dark: "#f47d3c",
    darker: "#f37028",
    darkest: "#e55a0d"
  },
  error: {
    lightest: "#F2E3DB",
    light: "#E79888",
    base: "#F5775D",
    darker: "#F66346",
    darkest: "#F14723"
  },
  alert: {
    info: "var(--t-fill-color-alert-info)",
    success: "var(--t-fill-color-alert-success)",
    warning: "var(--t-fill-color-alert-warning)",
    danger: "var(--t-fill-color-alert-error)"
  },

  "primary-lightest": "var(--t-fill-color-product-registrations-lightest)",
  "primary-lighter": "var(--t-fill-color-product-registrations-lighter)",
  "primary-light": "var(--t-fill-color-product-registrations-light)",
  "primary-dark": "var(--t-fill-color-product-registrations-dark)",
  "primary-darker": "var(--t-fill-color-product-registrations-darker)",
  "info-lighter": "var(--info-alert--background-color)",
  "info-dark": "var(--info-alert--text-color)",
  warning: "var(--warning-color)",
  "grey-0": "var(--t-fill-color-neutral-090)",
  "grey-1": "var(--t-fill-color-neutral-080)",
  "grey-2": "var(--t-fill-color-neutral-060)",
  "grey-3": "var(--t-fill-color-neutral-040)",
  "grey-4": "var(--t-fill-color-neutral-030)",
  "grey-5": "var(--t-fill-color-neutral-030)",
  "grey-6": "var(--t-fill-color-neutral-020)",
  "grey-7": "var(--t-fill-color-neutral-010)",
  "grey-8": "var(--t-fill-color-neutral-010)",
  linkForeground: "var(--t-fill-color-product-registrations-base)",
  separatorTertiary: "var(--pane--border-color)",
  highlight: "var(--t-fill-color-neutral-080)"
}
